import React from 'react';

export default class VimeoThumbnail extends React.Component {
    
    state = {
        src: '',
        srcSet: ''
    };

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.buildSrcSet();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.vimeoData !== this.props.vimeoData) {
            this.buildSrcSet();
        }
    }

    get data() {
        return this.props.data;
    }

    get vimeoData() {
        return this.props.vimeoData;
    }

    hasAnalyticsConsent() {
        return (typeof Cookiebot !== 'undefined') ? Cookiebot.consent?.statistics : true;
    }

    buildSrcSet() {
        if (!this.vimeoData || !this.vimeoData.thumbnail_url) {
            return;
        }

        // Vimeo thumbnail URLs usually look like: https://i.vimeocdn.com/video/123_640.jpg
        // We split at the underscore to get the base path.
        const thumbnailUrlBase = this.vimeoData.thumbnail_url.split('_')[0];
        
        this.setState({
            src: `${thumbnailUrlBase}_640x360.jpg`,
            srcSet: [
                `${thumbnailUrlBase}_100x75.jpg 100w`,
                `${thumbnailUrlBase}_200x150.jpg 200w`,
                `${thumbnailUrlBase}_295x166.jpg 295w`,
                `${thumbnailUrlBase}_640x360.jpg 640w`,
                `${thumbnailUrlBase}_960x540.jpg 960w`,
                `${thumbnailUrlBase}_1280x720.jpg 1280w`
            ].join(', ')
        });
    }

    onImageLinkClick = (event) => {
        if (!event) {
            return;
        }

        event.preventDefault();

        if ((this.data.settings.thumbnail_on_click_active ?? null == 'yes') && window.dataLayer && this.hasAnalyticsConsent()) {
            const analyticsData = {
                id: this.data.node,
                label: (this.data.settings.analytics_label) ? this.data.settings.analytics_label : this.vimeoData.title ?? `Vimeo ID: ${this.data.settings.video_id}`,
                pageUrl: location.href
            };

            window.dataLayer.push({
                event: 'vimeoThumbnailClick',
                ...analyticsData
            });
        }
    }

    render() {
        if (!this.vimeoData) {
            return <div className="vimeo-thumbnail-placeholder" style={{ aspectRatio: '16/9', background: '#eee' }} />;
        }

        return (
            <a 
                className={`vimeo-thumbnail ${this.data.settings.thumbnail_classes ?? ''}`}
                href="#"
                title="Click here to watch the video."
                aria-label={`Play video: ${this.vimeoData.title}`}
                data-lum-vimeo-card-modal={this.data.settings.modal_id} 
                role="button"
                onClick={this.onImageLinkClick}
                tabIndex="0"
            >
                <img 
                    className="vimeo-thumbnail"
                    src={this.state.src}
                    srcSet={this.state.srcSet}
                    sizes="(max-width: 640px) 100vw, 640px"
                    alt="" // Alt is empty because the aria-label on the parent link describes the action
                    aria-hidden="true" // Prevents screen readers from reading the image separately from the link
                    loading="lazy"
                />
                <svg className="vimeo-thumbnail-play-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 55 55" width="55" height="55" aria-hidden="true">
                    <circle cx="27.5" cy="27.5" r="27.5"/>
                    <path d="M21 17.5 L41 27.5 L21 37.5 Z"/>
                </svg>

            </a>
        );
    }
}
